export const WEAPON_MOUNT = {
  window: [0.78, 0.88, -0.46],
  muzzle: [1.24, 1.01, 0.84],
} as const
